export default "__VITE_ASSET__BmtaHC1Z__"